var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.376 17.1305C20.6947 22.4478 21.9013 16.2963 25.2878 19.6804C28.5527 22.9443 30.4291 23.5983 26.2926 27.7336C25.7745 28.15 22.4825 33.1597 10.9131 21.5935C-0.657656 10.026 4.3491 6.73058 4.76561 6.21258C8.91214 2.06578 9.5548 3.95316 12.8196 7.21709C16.2061 10.6026 10.0572 11.8132 15.376 17.1305Z",
    fill: "#0799B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.7a04bf2e94622a58ccdab65f6572cc53.svg";
export { ForwardRef as ReactComponent };